import { createPinia } from 'pinia'
import localForagePersist from '../plugins/localForagePersist'
import { createORM } from 'pinia-orm'

const pinia = createPinia().use(createORM())

// Use LocalForage for state persistence
pinia.use(localForagePersist)

export default pinia
